module.exports = __webpack_public_path__ + "static/img/cart.a51c4fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cart.png
// module id = TIOo
// module chunks = 1